import { render, staticRenderFns } from "./FabSaveModal.vue?vue&type=template&id=472ef582&slot=items&"
import script from "./FabSaveModal.script.js?vue&type=script&lang=js&"
export * from "./FabSaveModal.script.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports